/**
 * Languages that use imperial units (miles) for distance measurements
 */
export const IMPERIAL_CULTURES = ['US', 'GB'] as const;
